// extracted by mini-css-extract-plugin
export default {"container":"Order_container__AbjWj","orders__container":"Order_orders__container__xMe-Q"};